import Vue from 'vue'

import App from './App.vue'
import router from './router/router'
import store from './share/MyShare'
import utils from './share/MyUtils'

import ElementUI from 'element-ui';
import HttpRequest from './request/HttpRequest.js'
import 'element-ui/lib/theme-chalk/index.css';
Vue.prototype.$utils = utils;
Vue.prototype.$axios = HttpRequest.requestAxios;
Vue.prototype.$requetUrl = HttpRequest.requetUrl;
Vue.config.productionTip = false
Vue.use(ElementUI);

new Vue({
	store,
	router,
	render: h => h(App),

}).$mount('#app')


